import axiosInstance from '@/utils/axiosInstance.js'
import SERVICES from '@/utils/servicesUtil.js'
// import axios from 'axios'

// let axios2 = axios.create({ baseURL: 'https://localhost:5002/services/'}) // usado quando foram testasdos dsois serviços ao mesmo tempo no mesmo computador(depreciado)

const NOTIFICATION = '/notification/api/v1.0/Notification'
const USER = '/user/api/v1.0/user'

const getNotification = ($Limit, $Count) => axiosInstance.get(`${NOTIFICATION}/${$Limit}/${$Count}`)

const getMore = ($Limit, $skip, $NotificationId) => axiosInstance.get(`${NOTIFICATION}/get-more/${$Limit}/${$skip}/${$NotificationId}`)

const getNew = ($NotificationId) => axiosInstance.get(`${NOTIFICATION}/get-new/${$NotificationId}`)

const markAsRead = ($NotificationsIds) => axiosInstance.patch(`${NOTIFICATION}/mark-as-read`, $NotificationsIds)

const clearAll = () => axiosInstance.delete(`${NOTIFICATION}`)

const removeOne = ($NotificationId) => axiosInstance.delete(`${NOTIFICATION}/${$NotificationId}`)

const logout = () => axiosInstance.post(`${SERVICES.AUTH}/logout`)

const getOrganizationsByUser = ($UserId, $getDescendent) =>
  axiosInstance.get(`${USER}/organizations`, { params: { IncludeDescendentOrganizations: $getDescendent } })

const notifyPaymentError = (organizationId, body) => axiosInstance.post(`${NOTIFICATION}/notify-payment-error/${organizationId}`, body)

export default {
  getNotification,
  getMore,
  getNew,
  markAsRead,
  clearAll,
  removeOne,
  logout,
  getOrganizationsByUser,
  notifyPaymentError,
}
